import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { LongStringField, CheckboxField } from "cxa-form-field";
import { renderField, RadioButtonGroupRow } from "./components";
import { validateRequired } from "./validation";

const StyledForm = ({ renderValue }) => (
  <div style={{ padding: 10 }}>
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td>
            <img src="/assets/images/hdf/aviva-logo.png" alt="Aviva" style={{ width: "10vw" }} />
          </td>
          <td
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16pt",
              verticalAlign: "middle",
              width: "80%",
            }}
          >
            HEALTH DECLARATION FORM
          </td>
          <td>
            <div style={{ border: "1px solid #000", padding: 10, width: 190 }}>
              For Official Use Only
              <br />
              Group Policy No:
              <br />
              <table style={{ borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid #000", width: 20 }} />
                    <td style={{ border: "1px solid #000", width: 20 }} />
                    <td style={{ border: "1px solid #000", width: 20 }} />
                    <td style={{ border: "1px solid #000", width: 20 }} />
                    <td style={{ border: "1px solid #000", width: 20 }} />
                    <td style={{ border: "1px solid #000", width: 20 }} />
                    <td style={{ border: "1px solid #000", width: 20 }} />
                    <td style={{ border: "1px solid #000", width: 20 }} />
                  </tr>
                </tbody>
              </table>
              <br />
              <table>
                <tbody>
                  <tr>
                    <td>Date:</td>
                    <td
                      style={{
                        width: "80%",
                        borderBottom: "1px solid #000",
                      }}
                    />
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    &nbsp;
    <br />
    <div
      style={{
        color: "#f00",
        fontWeight: "bold",
        fontSize: "12pt",
        padding: 10,
        border: "1px solid #000",
      }}
    >
      IMPORTANT NOTE: Pursuant to Section 25(5) of the Insurance Act (Cap. 142), you are to disclose
      in this form, fully and faithfully, all the facts <br />
      which you know or ought to know, otherwise, nothing may be payable under the Policy.
    </div>
    <br />
    <table>
      <tbody>
        <tr>
          <td>Name of Company: </td>
          <td style={{ borderBottom: "1px solid #000", minWidth: 200 }} />
        </tr>
      </tbody>
    </table>
    <table>
      <tbody>
        <tr>
          <td>Plan Type: </td>
          <td style={{ borderBottom: "1px solid #000", minWidth: 200 }} />
        </tr>
      </tbody>
    </table>
    &nbsp;
    <br />
    <span style={{ fontWeight: "bold" }}>{"(A) EMPLOYEE'S PARTICULARS"}</span>
    <table style={{ borderCollapse: "collapse" }}>
      <tbody>
        <tr>
          <td style={{ border: "1px solid #000", padding: 5 }} colSpan={4}>
            Full Name of Proposed Insured in Block (as shown in NRIC - underline surname)
            <br />
            <div style={{ paddingTop: 5 }} id="RO_EmployeeName">
              {renderValue({
                fieldName: "EmployeeName",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={{ border: "1px solid #000" }} colSpan={2}>
            <table style={{ borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ borderRight: "1px solid #000", padding: 5 }}>
                    Nationality.
                    <div style={{ paddingTop: 5 }}>
                      <Field
                        name="Nationality"
                        type="text"
                        component={renderField}
                        label="Nationality"
                        validate={validateRequired}
                        style={{ width: 200 }}
                      />
                    </div>
                  </td>
                  <td style={{ borderRight: "1px solid #000", padding: 5 }}>
                    Country of Residence
                    <div style={{ paddingTop: 5 }}>
                      <Field
                        name="CountryOfResidence"
                        type="text"
                        component={renderField}
                        label="CountryOfResidence"
                        validate={validateRequired}
                        style={{ width: 200 }}
                      />
                    </div>
                  </td>
                  <td style={{ borderRight: "1px solid #000", padding: 5 }}>
                    Height(cm)
                    <div style={{ paddingTop: 5 }}>
                      <Field
                        name="Height"
                        type="text"
                        component={renderField}
                        label="Height"
                        validate={validateRequired}
                        style={{ width: 50 }}
                      />
                    </div>
                  </td>
                  <td style={{ padding: 5 }}>
                    Weight(kg)
                    <div style={{ paddingTop: 5 }}>
                      <Field
                        name="Weight"
                        type="text"
                        component={renderField}
                        label="Weight"
                        validate={validateRequired}
                        style={{ width: 50 }}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            NRIC / Passport No.
            <div style={{ paddingTop: 5 }} id="RO_Identification">
              {renderValue({
                fieldName: "Identification",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Date of Birth
            <div style={{ paddingTop: 5 }} id="RO_BirthDate">
              {renderValue({ fieldName: "BirthDate", fieldFormat: "date" })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Sex
            <br />
            <div style={{ paddingTop: 5 }} id="RO_Gender">
              {renderValue({ fieldName: "Gender", fieldFormat: "text" })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Marital Status
            <div style={{ paddingTop: 5 }} id="RO_MaritalStatus">
              {renderValue({
                fieldName: "MaritalStatus",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Occupation - Exact Duties
            <div style={{ paddingTop: 5 }}>
              <Field
                name="JobTitle"
                type="text"
                component={renderField}
                label="JobTitle"
                validate={validateRequired}
                style={{ width: 500 }}
              />
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Date of Employment
            <div style={{ paddingTop: 5 }} id="RO_JoinDate">
              {renderValue({ fieldName: "JoinDate", fieldFormat: "date" })}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    &nbsp;
    <br />
    <span style={{ fontWeight: "bold" }}>
      {"(B) DEPENDANTS' INFORMATION (Please ignore this section if dependants are not covered)"}
    </span>
    <table style={{ borderCollapse: "collapse" }} className="normalPadded">
      <tbody>
        <tr>
          <td style={{ fontWeight: "bold", border: "1px solid #000" }}>Relationship</td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Name
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Occupation
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            NRIC / Passport No.
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Nationality
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Country of Residence
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Sex
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Date of Birth
            <br />
            (DD / MM / YY)
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Height
            <br />
            (cm)
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "center",
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Weight
            <br />
            (kg)
          </td>
        </tr>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Dependant 1
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep1Name"
          >
            {renderValue({ fieldName: "Dep1Name", fieldFormat: "text" })}
            <Field component={renderField} type="hidden" name="Dep1Name" />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep1Occupation"
              type="text"
              component={renderField}
              label="Dep1Occupation"
              style={{ width: 200 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep1Identification"
          >
            {renderValue({
              fieldName: "Dep1Identification",
              fieldFormat: "text",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep1Nationality"
              type="text"
              component={renderField}
              label="Dep1Nationality"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep1CountryOfResidence"
              type="text"
              component={renderField}
              label="Dep1CountryOfResidence"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep1Gender"
          >
            {renderValue({ fieldName: "Dep1Gender", fieldFormat: "text" })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep1BirthDate"
          >
            {renderValue({
              fieldName: "Dep1BirthDate",
              fieldFormat: "date",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep1Height"
              type="text"
              component={renderField}
              label="Dep1Height"
              style={{ width: 50 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep1Weight"
              type="text"
              component={renderField}
              label="Dep1Weight"
              style={{ width: 50 }}
            />
          </td>
        </tr>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Dependant 2
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep2Name"
          >
            {renderValue({ fieldName: "Dep2Name", fieldFormat: "text" })}
            <Field component={renderField} type="hidden" name="Dep2Name" />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep2Occupation"
              type="text"
              component={renderField}
              label="Dep2Occupation"
              style={{ width: 200 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep2Identification"
          >
            {renderValue({
              fieldName: "Dep2Identification",
              fieldFormat: "text",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep2Nationality"
              type="text"
              component={renderField}
              label="Dep2Nationality"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep2CountryOfResidence"
              type="text"
              component={renderField}
              label="Dep2CountryOfResidence"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep2Gender"
          >
            {renderValue({ fieldName: "Dep2Gender", fieldFormat: "text" })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep2BirthDate"
          >
            {renderValue({
              fieldName: "Dep2BirthDate",
              fieldFormat: "date",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep2Height"
              type="text"
              component={renderField}
              label="Dep2Height"
              style={{ width: 50 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep2Weight"
              type="text"
              component={renderField}
              label="Dep2Weight"
              style={{ width: 50 }}
            />
          </td>
        </tr>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Dependant 3
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep3Name"
          >
            {renderValue({ fieldName: "Dep3Name", fieldFormat: "text" })}
            <Field component={renderField} type="hidden" name="Dep3Name" />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep3Occupation"
              type="text"
              component={renderField}
              label="Dep3Occupation"
              style={{ width: 200 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep3Identification"
          >
            {renderValue({
              fieldName: "Dep3Identification",
              fieldFormat: "text",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep3Nationality"
              type="text"
              component={renderField}
              label="Dep3Nationality"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep3CountryOfResidence"
              type="text"
              component={renderField}
              label="Dep3CountryOfResidence"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep3Gender"
          >
            {renderValue({ fieldName: "Dep3Gender", fieldFormat: "text" })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep3BirthDate"
          >
            {renderValue({
              fieldName: "Dep3BirthDate",
              fieldFormat: "date",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep3Height"
              type="text"
              component={renderField}
              label="Dep3Height"
              style={{ width: 50 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep3Weight"
              type="text"
              component={renderField}
              label="Dep3Weight"
              style={{ width: 50 }}
            />
          </td>
        </tr>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            Dependant 4
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep4Name"
          >
            {renderValue({ fieldName: "Dep4Name", fieldFormat: "text" })}
            <Field component={renderField} type="hidden" name="Dep4Name" />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep4Occupation"
              type="text"
              component={renderField}
              label="Dep4Occupation"
              style={{ width: 200 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep4Identification"
          >
            {renderValue({
              fieldName: "Dep4Identification",
              fieldFormat: "text",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep4Nationality"
              type="text"
              component={renderField}
              label="Dep4Nationality"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep4CountryOfResidence"
              type="text"
              component={renderField}
              label="Dep4CountryOfResidence"
              style={{ width: 150 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep4Gender"
          >
            {renderValue({ fieldName: "Dep4Gender", fieldFormat: "text" })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            id="RO_Dep4BirthDate"
          >
            {renderValue({
              fieldName: "Dep4BirthDate",
              fieldFormat: "date",
            })}
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep4Height"
              type="text"
              component={renderField}
              label="Dep4Height"
              style={{ width: 50 }}
            />
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <Field
              name="Dep4Weight"
              type="text"
              component={renderField}
              label="Dep4Height"
              style={{ width: 50 }}
            />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table className="normalPadded" style={{ borderCollapse: "collapse" }}>
      <tbody>
        <tr>
          <td rowSpan={2} style={{ borderBottom: "1px solid #000", paddingLeft: 0 }}>
            <span style={{ fontWeight: "bold" }}>(C) HEALTH QUESTIONS</span>
          </td>
          <td
            style={{
              border: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Employee
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 1
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 2
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 3
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 4
          </td>
        </tr>
        <tr>
          <td
            style={{
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            Yes
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            No
          </td>
          <td
            style={{
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            Yes
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            No
          </td>
          <td
            style={{
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            Yes
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            No
          </td>
          <td
            style={{
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            Yes
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            No
          </td>
          <td
            style={{
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            Yes
          </td>
          <td
            style={{
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              textAlign: "center",
            }}
          >
            No
          </td>
        </tr>
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            1. Have you ever had or been told to have or been treated for:
          </td>
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="a. epilepsy / fits, stroke, paralysis / weakness of limb, prolonged headache, nervous breakdown, depression or any other nervous / mental disorders?"
          questionId="MentalDisorders"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="b. ear discharge, nose bleeds, double vision, impaired sight, hearing or speech or any other disorders of ear, eye, nose and throat?"
          questionId="HearingAndSight"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="c. asthma, bronchitis, persistent cough, coughing with blood, pneumonia, tuberculosis, breathing complaints / discomfort or any other lung disorders?"
          questionId="LungDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="d. raise cholestrol, high blood pressure, heart attack, mitral valve prolapse or other heart valve disorders, breathelessness, fast heart rate, chest pain, or any disease or disorders of the heart or blood vessels?"
          questionId="HeartDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="e. diabetes mellitus, thyroid disorders or any endocrine disorders?"
          questionId="EndocrineDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="f. gastritis, stomach or duodenal ulcer, blood in stools, fistula, piles or any other stomach or bowel disorder?"
          questionId="BowelDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="g. jaundice, hepatitis B carrier or any other form of hepatitis, liver or gallbladder disorder?"
          questionId="GallbladderDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="h. blood, protein or sugar in urine, kidney stones, infection or any other disorders of the kidney, bladder or genital organs?"
          questionId="KidneyDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="i. cancer, tumour, cyst or growth of any kind?"
          questionId="Cancer"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="j. slipped disc, backache, gout, arthrutis, pain or deformity or disorders of the muscles, spine, limbs or joints or severe injury?"
          questionId="PhysicalInjury"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="k. any sexually transmitted disease, e.g. syphlilis, gonorrhoea, non-specific urethritis, herpes, HIV infection or AIDS?"
          questionId="SexualDisease"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="l. endometriosis, fibrs, cysts, breast lumps, abnormal pap smear, irregular or painful menstruation or any other disorders of the female organ?"
          questionId="FemaleDisease"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="m. anaemia, haemophilia or any disorders of the blood?"
          questionId="BloodDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="n. any other illnesses, disorder, operation, physical disability, accident, hospitalisation, congenital or hereditary disorders not listed above?"
          questionId="OtherDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="2. Have you smoked in the last 12 months?"
          questionId="Smoke"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 20,
              borderRight: "1px solid #000",
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td>
                    {"If 'Yes', please state number of years and the number of sticks per day."}
                  </td>
                  <td style={{ width: 170 }}>
                    <table
                      className="normalPadded"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            No. of sticks/day
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            No. of years
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="EmpSmokeQuantity"
                      type="text"
                      component={renderField}
                      label="EmpSmokeQuantity"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="EmpSmokeNoOfYears"
                      type="text"
                      component={renderField}
                      label="EmpSmokeNoOfYears"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep1SmokeQuantity"
                      type="text"
                      component={renderField}
                      label="Dep1SmokeQuantity"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep1SmokeNoOfYears"
                      type="text"
                      component={renderField}
                      label="Dep1SmokeNoOfYears"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep2SmokeQuantity"
                      type="text"
                      component={renderField}
                      label="Dep2SmokeQuantity"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep2SmokeNoOfYears"
                      type="text"
                      component={renderField}
                      label="Dep2SmokeNoOfYears"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep3SmokeQuantity"
                      type="text"
                      component={renderField}
                      label="Dep3SmokeQuantity"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep3SmokeNoOfYears"
                      type="text"
                      component={renderField}
                      label="Dep3SmokeNoOfYears"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep4SmokeQuantity"
                      type="text"
                      component={renderField}
                      label="Dep4SmokeQuantity"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep4SmokeNoOfYears"
                      type="text"
                      component={renderField}
                      label="Dep4SmokeNoOfYears"
                      value="Yes"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <RadioButtonGroupRow
          questionDesc="3. Do you consume alcohol?"
          questionId="ConsumeAlcohol"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 20,
              borderRight: "1px solid #000",
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td>{"If 'Yes', please state the type, quantity and frequency."}</td>
                  <td style={{ width: 170 }}>
                    <table
                      className="normalPadded"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            Type
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            Quantity
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            Frequency (per week)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="EmpAlcoholType"
                      type="text"
                      component={renderField}
                      label="EmpAlcoholType"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="EmpAlcoholQuantity"
                      type="text"
                      component={renderField}
                      label="EmpAlcoholQuantity"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="EmpAlcoholFrequencyPerWeek"
                      type="text"
                      component={renderField}
                      label="EmpAlcoholFrequencyPerWeek"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep1AlcoholType"
                      type="text"
                      component={renderField}
                      label="Dep1AlcoholType"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep1AlcoholQuantity"
                      type="text"
                      component={renderField}
                      label="Dep1AlcoholQuantity"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep1AlcoholFrequencyPerWeek"
                      type="text"
                      component={renderField}
                      label="Dep1AlcoholFrequencyPerWeek"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep2AlcoholType"
                      type="text"
                      component={renderField}
                      label="Dep2AlcoholType"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep2AlcoholQuantity"
                      type="text"
                      component={renderField}
                      label="Dep2AlcoholQuantity"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep2AlcoholFrequencyPerWeek"
                      type="text"
                      component={renderField}
                      label="Dep2AlcoholFrequencyPerWeek"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep3AlcoholType"
                      type="text"
                      component={renderField}
                      label="Dep3AlcoholType"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep3AlcoholQuantity"
                      type="text"
                      component={renderField}
                      label="Dep3AlcoholQuantity"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep3AlcoholFrequencyPerWeek"
                      type="text"
                      component={renderField}
                      label="Dep3AlcoholFrequencyPerWeek"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              textAlign: "center",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
            colSpan={2}
          >
            <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <Field
                      name="Dep4AlcoholType"
                      type="text"
                      component={renderField}
                      label="Dep4AlcoholType"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep4AlcoholQuantity"
                      type="text"
                      component={renderField}
                      label="Dep4AlcoholQuantity"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="Dep4AlcoholFrequencyPerWeek"
                      type="text"
                      component={renderField}
                      label="Dep4AlcoholFrequencyPerWeek"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <RadioButtonGroupRow
          questionDesc="4. Have you ever taken addictive drugs/narcotics or been treated for alcoholism or drug addiction?"
          questionId="DrugAddiction"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <RadioButtonGroupRow
          questionDesc="5. Do you have a regular doctor?"
          questionId="RegularDoc"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {[
                  "If 'Yes', please state the name and address of your regular ",
                  "doctor and the date, reason and result of last consultation.",
                ].join("")}
              </div>
              <LongStringField name="EmpRegularDocInfo" id="EmpRegularDocInfo" rows={3} cols={40} />
            </div>
          </td>
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="6. Have you consulted any doctor/specialist and had investigations done (X-Ray, ultrasound,
                      Electrocardiogram, blood or urine tests) and/or prescriptions, provided for any drugs or medications
                      for any medical conditions other than common illness e.g. flue, common cough etc?"
          questionId="Diagnosis"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {[
                  "If 'Yes', please state details such as reason, date and ",
                  "results of test done and the diagnosis.",
                ].join("")}
              </div>
              <LongStringField name="EmpDiagnosisInfo" id="EmpDiagnosisInfo" rows={3} cols={40} />
            </div>
          </td>
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="7. Have you been recommended by a doctor to receive any medical treatment, undergo any medical tests,
                      investigations (excluding voluntary health check-up) or any intention to consult any doctor for any reason,
                      seek futher treatment or alternative medicine?"
          questionId="MedTreatment"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {[
                  "If 'Yes', please state details such as type, reason, date ",
                  "and results of test done and the diagnosis.",
                ].join("")}
              </div>
              <LongStringField
                name="EmpMedTreatmentInfo"
                id="EmpMedTreatmentInfo"
                rows={3}
                cols={40}
              />
            </div>
          </td>
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="8. Do you engage in activities that will increase the likelihood of exposure to any immunity disorder
                      such as AIDS or AIDS-related conditions or in the last 3 months had experienced the following symptoms for
                      more than one week continuously: fatigue, weight loss, diarrhoea or unusual skin lesions?"
          questionId="HighRiskSexLife"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>{"If 'Yes', please state details."}</div>
              <LongStringField
                name="EmpHighRiskSexLifeInfo"
                id="EmpHighRiskSexLifeInfo"
                rows={3}
                cols={40}
              />
            </div>
          </td>
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="9. Have you ever been accepted at special terms or rates, deferred or declined for any application,
                      renewal or reinstatement of life, accident, health disability or other insurance policy?"
          questionId="Exclusions"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {[
                  "If 'Yes', please provide details on date of application and ",
                  "reason for special term.",
                ].join("")}
              </div>
              <LongStringField name="EmpExclusionsInfo" id="EmpExclusionsInfo" rows={3} cols={40} />
            </div>
          </td>
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="10. Do you engage or have any intention of engaging in hazardous activity or occupation such as private flying, scuba diving, motor racing, mountaineering etc?"
          questionId="Adventure"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {"If 'Yes', please state details such as locations, frequency, depth, etc."}
              </div>
              <LongStringField name="EmpAdventureInfo" id="EmpAdventureInfo" rows={3} cols={40} />
            </div>
          </td>
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
          <td style={{ paddingLeft: 30 }}>&nbsp;</td>
          <td style={{ paddingLeft: 30, borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="11. Have any of your natural parents or siblings died or suffered from  (a) heart disease,
                      (b) high blood pressure, (c) stroke, (d) diabetes, (e) cancer, (f) kidney disease, (g) mental disorder,
                      (h) muscular disorder, or any other hereditary disease?"
          questionId="GeneticMedicalCondition"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div>
              {[
                "If 'Yes', please state relationship, condition, age of ",
                "incidence of disease and age of death (if deceased).",
              ].join("")}
            </div>
          </td>
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
        </tr>
        <tr>
          <td
            style={{
              paddingLeft: 35,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <table style={{ borderCollapse: "collapse" }} className="normalPadded">
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Relationship
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Condition/Cause of Death
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Age at Onset
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    If Deceased,
                    <br />
                    Age at Death
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings1Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings1Relationship"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings1MedicalCondition"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings1MedicalCondition"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings1AgeOnset"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings1AgeOnset"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings1AgeAtDeath"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings1AgeAtDeath"
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings2Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings2Relationship"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings2MedicalCondition"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings2MedicalCondition"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings2AgeOnset"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings2AgeOnset"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings2AgeAtDeath"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings2AgeAtDeath"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            colSpan={10}
            style={{
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <table style={{ borderCollapse: "collapse" }} className="normalPadded">
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Relationship
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Condition/Cause of Death
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Age at Onset
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    If Deceased,
                    <br />
                    Age at Death
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings3Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings3Relationship"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings3MedicalCondition"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings3MedicalCondition"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings3AgeOnset"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings3AgeOnset"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings3AgeAtDeath"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings3AgeAtDeath"
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings4Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings4Relationship"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings4MedicalCondition"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings4MedicalCondition"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings4AgeOnset"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings4AgeOnset"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="ParentsSiblings4AgeAtDeath"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings4AgeAtDeath"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td colSpan={11} style={{ paddingLeft: 0, paddingRight: 0 }}>
            If any of the answers to Question 1 is YES, please PROVIDE COMPLETE INFORMATION and
            MEDICAL REPORT. If necessary, please attach a separate sheet.
            <br />
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td rowSpan={2} style={{ border: "1px solid #000", textAlign: "left" }}>
                    Name
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Sub-Qn.
                    <br /> (Eg. a,b)
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Details of Diagnosis / Treatment / Operation
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Date
                  </td>
                  <td rowSpan={2} style={{ border: "1px solid #000", textAlign: "left" }}>
                    Name & Address of Doctor / Hospital
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    From
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    To
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoName1"
                      type="text"
                      component={renderField}
                      label="MoreInfoName1"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoSubQNo1"
                      type="text"
                      component={renderField}
                      label="MoreInfoSubQNo1"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoDiagnosis1"
                      type="text"
                      component={renderField}
                      label="MoreInfoDiagnosis1"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoFrom1"
                      type="text"
                      component={renderField}
                      label="MoreInfoFrom1"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoTo1"
                      type="text"
                      component={renderField}
                      label="MoreInfoTo1"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoMedicalProvider1"
                      type="text"
                      component={renderField}
                      label="MoreInfoMedicalProvider1"
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoName2"
                      type="text"
                      component={renderField}
                      label="MoreInfoName2"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoSubQNo2"
                      type="text"
                      component={renderField}
                      label="MoreInfoSubQNo2"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoDiagnosis2"
                      type="text"
                      component={renderField}
                      label="MoreInfoDiagnosis2"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoFrom2"
                      type="text"
                      component={renderField}
                      label="MoreInfoFrom2"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoTo2"
                      type="text"
                      component={renderField}
                      label="MoreInfoTo2"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoMedicalProvider2"
                      type="text"
                      component={renderField}
                      label="MoreInfoMedicalProvider2"
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoName3"
                      type="text"
                      component={renderField}
                      label="MoreInfoName3"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoSubQNo3"
                      type="text"
                      component={renderField}
                      label="MoreInfoSubQNo3"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoDiagnosis3"
                      type="text"
                      component={renderField}
                      label="MoreInfoDiagnosis3"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoFrom3"
                      type="text"
                      component={renderField}
                      label="MoreInfoFrom3"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoTo3"
                      type="text"
                      component={renderField}
                      label="MoreInfoTo3"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoMedicalProvider3"
                      type="text"
                      component={renderField}
                      label="MoreInfoMedicalProvider3"
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoName4"
                      type="text"
                      component={renderField}
                      label="MoreInfoName4"
                      style={{ width: 150 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoSubQNo4"
                      type="text"
                      component={renderField}
                      label="MoreInfoSubQNo4"
                      style={{ width: 30 }}
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoDiagnosis4"
                      type="text"
                      component={renderField}
                      label="MoreInfoDiagnosis4"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoFrom4"
                      type="text"
                      component={renderField}
                      label="MoreInfoFrom4"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoTo4"
                      type="text"
                      component={renderField}
                      label="MoreInfoTo4"
                    />
                  </td>
                  <td style={{ border: "1px solid #000" }}>
                    <Field
                      name="MoreInfoMedicalProvider4"
                      type="text"
                      component={renderField}
                      label="MoreInfoMedicalProvider4"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: 0 }} colSpan={11}>
            <div
              style={{
                fontWeight: "bold",
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              (D) PERSONAL DATA CONSENT(S)
            </div>
            <div style={{ paddingBottom: 10 }}>
              On behalf of myself and my dependants, I/we consent to Aviva (and Aviva related group
              of companies) collecting, using and/or disclosing my/our personal data to issue and
              administer my existing and/or new policies or insurance coverage(s) with Aviva.
              <br />
              <br />
              On behalf of myself and my dependents, I/we also consent to Aviva (and Aviva related
              group of companies) transferring my/our personal data to Aviva related group of
              companies and/or third party service providers, reinsurers, suppliers or
              intermediaries, whether located in Singapore or elsewhere, for the above purposes.
              <br />
              <br />
              For full details of the purposes of collection, use and disclosure of your personal
              data, please visit{" "}
              <a href="http://www.aviva.com.sg/pdpa.html" target="_blank" rel="noopener noreferrer">
                http://www.aviva.com.sg/pdpa.html
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: 0 }} colSpan={11}>
            <div
              style={{
                fontWeight: "bold",
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              (E) DECLARATION
            </div>
            <div style={{ paddingBottom: 10 }}>
              I/We declare that all the information on this Application Form is true and complete to
              the best of my knowledge and understand that any misrepresentation or concealment of
              facts shall render the policy to be issued null and void. I agree that this
              application shall be the basis of the insurance coverage issued under the said Group
              Insurance Policy. I understand that the insurance coverage shall not become effective
              until it is accepted and confirmed in writing by Aviva Ltd.
            </div>
            <div style={{ paddingBottom: 10 }}>
              {[
                "I agree to inform Aviva Ltd if there is any change in the sate ",
                "of my and/or my dependants' health/activities between the date ",
                "of this Health Declaration and the date full insurance ",
                "coverage is provided by Aviva Ltd to me and/or my ",
                "dependant(s). I understand that the terms of accepting me ",
                "and/or my dependant(s) as a risk for insurance coverage may ",
                "vary according to such information received.",
              ].join("")}
            </div>
            <div style={{ paddingBottom: 10 }}>
              I consent to Aviva Ltd seeking information from any doctor who has attended to me
              and/or my dependant(s) or from other insurance company to which I and/or my
              dependant(s) have at any time made a proposal for insurance and I authorise the giving
              of such information. I further authorise Aviva Ltd to give such information obtained
              or information contained herein for the purpose of obtaining insurance cover under the
              said Group Policy to the insurance intermediary / administrator of the said Group
              Insurance Policy.
            </div>
            <div style={{ paddingBottom: 10 }}>
              I/We am/are aware that the produce I/We am/are applying for is authorised for sale in
              Singapore and I/we acknowledge that the laws and regulations applicable to my/our
              nationality and country of residence allows my/our purchase of this product. I/We
              understand that no liability can be accepted by Aviva for any legal consequences under
              the laws of other country or any tax implications that may arise in connection with
              my/our purchase of this product.
            </div>
            <div style={{ paddingBottom: 10, color: "#f00" }}>
              <span style={{ fontWeight: "bold" }}>
                Only applicable to Group Medical products for all voluntary and flexible benefits:
              </span>{" "}
              I/We confirm that I/we have received a copy of Your Guide to Health Insurance and
              Product Summary and have read and understood the contents of these two documents.
            </div>
            <br />
            <CheckboxField validate={validateRequired} name="declaration" id="declaration">
              <strong>I have read and accept this declaration</strong>
            </CheckboxField>
            <div style={{ paddingBottom: 10 }}>
              <center>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <span style={{ fontWeight: "bold" }}>
                          Health Declaration Form Completed On:
                        </span>
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #000",
                          width: 200,
                        }}
                        id="RO_CompletedOn"
                      >
                        {renderValue({
                          fieldName: "CompletedOn",
                          fieldFormat: "text",
                        })}
                      </td>
                      <td>by</td>
                      <td
                        style={{
                          borderBottom: "1px solid #000",
                          width: 200,
                        }}
                        id="RO_CompletedBy"
                      >
                        {renderValue({
                          fieldName: "CompletedBy",
                          fieldFormat: "text",
                        })}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </center>
            </div>
            <div style={{ textAlign: "center", paddingTop: 30 }}>
              Aviva Ltd&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4 Shenton Way #01-01 SGX Centre 2 Singapore
              068807&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Tel: (65) 6827 7988&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              Fax: (65) 6827 7706&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; www.aviva-singapore.com.sg
              <br />
              Company Reg. No.: 196900499K&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; GST Reg. No.: MR-8500166-8
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

StyledForm.propTypes = {
  renderValue: PropTypes.func.isRequired,
};

export default StyledForm;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/AVIVAHD201407.js